import axios from 'axios';
const BACKEND_URL_AZURE = 'https://heurigenkalender-klosterneuburg-service.azurewebsites.net/api/HttpTriggerGetHeurigen?code=Hde_EapvquER0zyi2z9jgP65rd9LRt_I1qRmkfS3JYa-AzFuuSR4-w==';
const BACKEND_URL_AZURE2 = 'https://heurigenkalender-klosterneuburg-service.azurewebsites.net/api/HttpTriggerGetMaxTsHeurigen?code=eSeq3YlAtyKpNuToan5j3z8P4Ak43MGyYimxbQrkdRnpAzFuLUxBuA==';

export async function latestHeurigenUpdateDb() {
    let fetchResult = {
        data: [],
        status: 'unknown'
    };
    try {
        let response = await axios.get(BACKEND_URL_AZURE2);
        fetchResult.status = response.status;
        let lastUpdate = new Date(response.data.data[0].lastUpdate);
        // console.log('response.data', response.data);
        // console.log('lastUpdate', lastUpdate);
        return lastUpdate;
    } catch {
       console.log('http-heurigen/latestHeurigenUpdateDb: ERROR receiving HttpTriggerGetMaxTsHeurigen');
    }
}

export async function fetchHeurigen() {
    let response;
    let heurigen = [];
    let fetchResult = {
        data: [],
        status: 'unknown'
    };

    try {
        response = await axios.get(BACKEND_URL_AZURE);
        fetchResult.status = response.status;
            for (let i = 0; i < response.data.data.length; i++) {
                
                    const heuriger = {
                        id: response.data.data[i].id,                        
                        name: response.data.data[i].name,
                        shortName: response.data.data[i].shortName,
                        hide: response.data.data[i].hide,
                        location: response.data.data[i].location,
                        address1: response.data.data[i].address1,
                        address2: response.data.data[i].address2,
                        logoBackgroundColor: response.data.data[i].logoBackgroundColor,
                        phone: response.data.data[i].phone,
                        email: response.data.data[i].email,
                        web: response.data.data[i].web,
                        imageUrl: response.data.data[i].imageUrl,
                        openingsDaysText: response.data.data[i]?.openingsDaysText,
                        closingDays: response.data.data[i]?.closingDays,
                        _ts: response.data.data[i]._ts,
                    }
                    heurigen.push(heuriger);
                    // if(heuriger.name === 'Test') { console.log('heuriger', heuriger)}
            }
            
        fetchResult.data = heurigen;
        
    } catch {
        console.log('http-heurigen/fetchHeurigen: ERROR receiving HttpTriggerGetHeurigen');
    }
    return fetchResult;
}